module.exports = __webpack_public_path__ + "static/img/banner_solutions_system.9a1c7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_system.png
// module id = IQGX
// module chunks = 10